import http from '../../Common/api';
import generateQueryParamsUrl from '../../Common/utils/queryParamsGenerator';

import { rejectedUrl, partnersUrl, agenciesUrl } from './constants';
import {
  normalizeRejects,
  normalizePartners,
  normalizeAgencies,
  normalizeRejectedDetails,
} from './normalizers';

const getRejectedReports = async (filters = {}) => {
  try {
    const searchBy = generateQueryParamsUrl(rejectedUrl, filters);
    const rejectedReports = await http.get(searchBy);

    return normalizeRejects(rejectedReports);
  } catch (error) {
    return {
      rejects: [],
      totalRecords: 0,
    };
  }
};

const getRejectedDetails = async rejectedID => {
  try {
    const rejectedDetails = await http.get(`${rejectedUrl}${rejectedID}/`);

    return normalizeRejectedDetails(rejectedDetails);
  } catch {
    return normalizeRejectedDetails();
  }
};

const getPartners = async () => {
  try {
    const partners = await http.get(partnersUrl);

    return normalizePartners(partners);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getAgencies = async ({ filters = {} }) => {
  try {
    const searchBy = generateQueryParamsUrl(agenciesUrl, filters);
    const agencies = await http.get(searchBy);

    return normalizeAgencies(agencies);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getRejectedFilterOptions = async () => Promise.all([getPartners(), getAgencies({})]);

export { getRejectedReports, getRejectedFilterOptions, getRejectedDetails, getAgencies };
